import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';

import { DateAdapter } from '@angular/material/core';
import {
  NavigationHeaderComponent,
  headerItem,
} from '@standard-angular-utilities/shared-components';
import { UserService } from 'src/app/Services/user-service';
import assetsRouteConfig from './Routes';
import { SharedFunctionsService } from 'src/app/Services/sharedFunctions.service';
@Component({
  selector: 'assets-base-root',
  templateUrl: './assets-base.component.html',
  styleUrl: './assets-base.component.css',
  imports: [RouterModule, RouterOutlet, NavigationHeaderComponent],
})
export class AssetsBaseComponent {
  get currentUser() {
    return this.userService.currentUser;
  }
  constructor(
    public userService: UserService,
    private sharedFunctionsService: SharedFunctionsService
  ) {
    if (!this.currentUser) {
      this.userService.userStatusChanged$.subscribe((result) => {
        if (result) {
          this.addRoutes();
        }
      });
    } else {
      this.addRoutes();
    }
  }

  addRoutes() {
    if (!this.currentUser) {
      return;
    }

    this.userService.setRouteConfig(assetsRouteConfig);
  }
}
